import React from 'react';
export function Footer() {
  return <footer className="bg-black border-t border-gray-900 py-8 px-4 text-center" data-id="element-152">
      <div className="max-w-3xl mx-auto" data-id="element-153">
        <div className="inline-flex items-center gap-2 text-green-400 font-bold text-xl mb-4" data-id="element-154">
          <span data-id="element-155">🥗</span> TU MANUAL DIGITAL™
        </div>

        <p className="text-gray-400 mb-6 max-w-md mx-auto" data-id="element-156">
          El sistema de consultorio N°1 para nutricionistas independientes en
          Argentina.
        </p>

        <div className="flex flex-col items-center gap-2 text-sm text-gray-500 mb-8" data-id="element-157">
          <a href="mailto:soporte.tumanualdigital@gmail.com" className="hover:text-green-400 transition-colors" data-id="element-158">
            📧 soporte.tumanualdigital@gmail.com
          </a>
          <a href="https://www.tumanualdigital.com" target="_blank" rel="noopener noreferrer" className="hover:text-green-400 transition-colors" data-id="element-159">
            🌐 www.tumanualdigital.com
          </a>
        </div>

        <div className="text-xs text-gray-600 space-y-2" data-id="element-160">
          <p data-id="element-161">© Tu Manual Digital™ 2025 · Todos los derechos reservados</p>
          <p className="italic" data-id="element-162">"El próximo domingo puede ser diferente." 🥗</p>
        </div>
      </div>
    </footer>;
}